module.exports = __webpack_public_path__ + "img/MGH-Gaien-11.2084c869.jpg";